import { SendTextOrderFormContainer } from "src/app/containers";
import { IActionsModal } from "src/app/types/actionsModal";

const SendTextOrderFormContainerWithChecked = (props: IActionsModal<{ id: number }>) => {
    const { handleClose, entity, updateGridOnSave } = props;
    return (
        <SendTextOrderFormContainer
            handleClose={handleClose}
            entity={entity}
            updateGridOnSave={updateGridOnSave}
            checkChanges={true}
        />
    );
};

export default SendTextOrderFormContainerWithChecked;
